const apiUrl = "https://marsiweb.com/padelapi/api/availability";

export async function getMyAvailability(token) {
  const res = await fetch(apiUrl, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return await res.json();
}

export async function setAvailability(token, date, hour) {
  await fetch(apiUrl, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ date, hour }),
  });
}

export async function deleteAvailability(token, date, hour) {
  await fetch(apiUrl, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ date, hour }),
  });
}
